export default {"src":"/_next/static/media/New_Project.f70bd7a2.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};